import React from 'react'
import {UniLink} from '../unilink/index'
import Box from '../box/Box'

class Card extends React.PureComponent {
  render() {
    const {children, onClick, to, href, type, ...rest} = this.props
    let isLink = false

    if (onClick || to || href) {
      isLink = true
    }

    const {
      /*
      paddingX,
      paddingY,
      smPaddingX,
      smPaddingY,
      mdPaddingX,
      mdPaddingY,
      lgPaddingX,
      lgPaddingY,
      paddingTop,
      paddingBottom,
      paddingLeft,
      paddingRight,
      smPaddingTop,
      smPaddingBottom,
      smPaddingLeft,
      smPaddingRight,
      mdPaddingTop,
      mdPaddingBottom,
      mdPaddingLeft,
      mdPaddingRight,
      lgPaddingTop,
      lgPaddingBottom,
      lgPaddingLeft,
      lgPaddingRight,
      shadow,
      shape,
      clickable,
      */
      color = 'white',
      ...boxProps
    } = rest



    if (isLink) {
      return (
        <Box
          paddingY={6}
          paddingX={4}
          smPaddingX={10}
          clickable
          shadow
          shape='round'
          color={color}
          {...boxProps}
        >
          <UniLink onClick={onClick} to={to} href={href} type={type} style={{width: '100%', height: '100%'}}>
            {children}
          </UniLink>
        </Box>
      )
    } else {
      return (
        <Box
          paddingY={6}
          paddingX={4}
          smPaddingX={10}
          shape='round'
          shadow
          color={color}
          {...boxProps}
        >
          {children}
        </Box>
      )
    }

  }
}

export default Card



// WEBPACK FOOTER //
// ./src/core/components/card/Card.js